export enum TravelGoalDescriptionEnum {
  BusinessTrip = 'business_trip',
  CompetitiveSports = 'competitive_sports',
  Diving = 'diving',
  ExtremeSports = 'extreme_sports',
  HighRiskSports = 'high_risk_sports',
  PhysicalWork = 'physical_work',
  Sightseeing = 'sightseeing',
  Skiing = 'skiing',
}
